<div echarts [options]="getOptions()"></div>
